module.exports = __webpack_public_path__ + "media/dr-mario.5af83615.wav";